/**
 * localStorage-backed drafts for the Register Client wizard.
 * Multiple named drafts, global to the admin panel (no tenant namespace needed).
 *
 * Draft shape: { id, name, currentStep, updatedAt, data }
 *  - data is the full flat form object (logos stored as URL strings — JSON-safe).
 */

const STORAGE_KEY = "admin_register_client_drafts";

export function listDrafts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr)
      ? arr.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))
      : [];
  } catch {
    return [];
  }
}

export function getDraft(id) {
  return listDrafts().find((d) => String(d.id) === String(id)) || null;
}

export function saveDraft(draft) {
  const drafts = listDrafts();
  const saved = { ...draft, updatedAt: Date.now() };
  const idx = drafts.findIndex((d) => String(d.id) === String(saved.id));
  if (idx >= 0) drafts[idx] = saved;
  else drafts.push(saved);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
  } catch (e) {
    console.error("clientDrafts.saveDraft failed", e);
  }
  return saved;
}

export function deleteDraft(id) {
  const drafts = listDrafts().filter((d) => String(d.id) !== String(id));
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
  } catch (e) {
    console.error("clientDrafts.deleteDraft failed", e);
  }
}
